/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

if(window.location.href === "https://www.beamer.at/collections/beamer/Businessprojektor") window.location.replace("https://www.beamer.at/collections/beamer/businessprojektor");
if(window.location.href === "https://www.beamer.at/collections/beamer/Installationsprojektor") window.location.replace("https://www.beamer.at/collections/beamer/installationsprojektor");
if(window.location.href === "https://www.beamer.at/collections/beamer/Kurzdistanzprojektor") window.location.replace("https://www.beamer.at/collections/beamer/kurzdistanzprojektor");
if(window.location.href === "https://www.beamer.at/collections/beamer/Schulprojektor") window.location.replace("https://www.beamer.at/collections/beamer/schulprojektor");
if(window.location.href === "https://www.beamer.at/collections/beamer/Ultrakurzdistanzprojektor") window.location.replace("https://www.beamer.at/collections/beamer/ultrakurzdistanzprojektor");
if(window.location.href === "https://www.beamer.at/collections/beamer/Motorleinwand") window.location.replace("https://www.beamer.at/collections/beamer/motorleinwand");
if(window.location.href === "https://www.beamer.at/collections/beamer/Videokonferenzbar") window.location.replace("https://www.beamer.at/collections/beamer/videokonferenzbar");
if(window.location.href === "https://www.beamer.at/collections/beamer/Videokonferenzsysteme") window.location.replace("https://www.beamer.at/collections/beamer/videokonferenzsysteme");
if(window.location.href === "https://www.beamer.at/collections/beamer/Videokonferenzkamera") window.location.replace("https://www.beamer.at/collections/beamer/videokonferenzkamera");
if(window.location.href === "https://www.beamer.at/collections/beamer/Videokonferenzdisplay") window.location.replace("https://www.beamer.at/collections/beamer/videokonferenzdisplay");
if(window.location.href === "https://www.beamer.at/collections/beamer/Raumbuchungssystem") window.location.replace("https://www.beamer.at/collections/beamer/raumbuchungssystem");


document.addEventListener('DOMContentLoaded', function() {
  
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }
  
  // Get the necessary cookie values
  const checkoutVisited = getCookie('checkoutVisited') === 'true' || 
                         sessionStorage.getItem('checkoutVisited') === 'true';
  const localization = getCookie('localization');
  
  if (checkoutVisited) {
    // If checkout visited is true, we need to check localization
    if (localization === 'AT') {
      // For AT, show B2B price (already displayed by default)
      setTimeout(function() {
        if(document.querySelector(".flickity-slider .b2b-price")) {
          document.querySelectorAll(".flickity-slider .b2b-price").forEach(item => {
            item.style.display = 'inline';
          })
    
          document.querySelectorAll(".flickity-slider .regular-price").forEach(item => {
            item.style.display = 'none';
          })    
        }
        
      }, 500)
      
    } else {

      // For DE or others, show regular price
      setTimeout(function() {
        if(document.querySelector(".flickity-slider .b2b-price")) {
          document.querySelectorAll(".flickity-slider .b2b-price").forEach(item => {
            item.style.display = 'none';
          })
    
          document.querySelectorAll(".flickity-slider .regular-price").forEach(item => {
            item.style.display = 'inline';
          })  
        }
        
      }, 500)
      
    }
  } else {

    // If checkout not visited, show B2B price (already displayed by default)

    setTimeout(function() {
      if(document.querySelector(".flickity-slider .b2b-price")) {
        document.querySelectorAll(".flickity-slider .b2b-price").forEach(item => {
          item.style.display = 'inline';
        })
  
        document.querySelectorAll(".flickity-slider .regular-price").forEach(item => {
          item.style.display = 'none';
        })  
      }
      
    }, 500)
      
  }
});



